module.exports = __webpack_public_path__ + "img/pakiet.3e61e90a.jpg";